/* eslint-disable */
const SMARTLOOK_KEY = import.meta.env.VITE_SMARTLOOK_KEY;

declare global {
  interface Window {
    smartlook: {
      (...args: unknown[]): void;
      api?: unknown[];
    };
  }
}

window.smartlook =
  window.smartlook ||
  function (...args: unknown[]) {
    ((window.smartlook as { api?: unknown[] }).api =
      (window.smartlook as { api?: unknown[] }).api ?? []).push(args);
  };

(function (d: Document) {
  const o = window.smartlook;
  const h = d.getElementsByTagName('head')[0];
  const c = d.createElement('script');
  o.api = [];
  c.async = true;
  c.type = 'text/javascript';
  c.charset = 'utf-8';
  c.src = 'https://web-sdk.smartlook.com/recorder.js';
  h.appendChild(c);
})(document);

window.smartlook('init', SMARTLOOK_KEY, {
  region: 'eu',
});

export {};
